// extracted by mini-css-extract-plugin
export default {"CargoForm":"CargoForm_CargoForm__ZeH+p","FieldRadio":"CargoForm_FieldRadio__gsmGG","FreightValueInput":"CargoForm_FreightValueInput__nc6D1"};